/*
 * Copyright (c) Worldline 2022.
 */

import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-cancellation',
  templateUrl: './cancellation.component.html'
})
export class CancellationComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
